import { useTranslation } from 'react-i18next';

import { SummaryBox } from '@app/dashboard/components/inner_layout/Cards/SummaryBox';
import { EMPTY_VALUE } from '@app/dashboard/constants/shared';

import { getTenure } from '../../utils';

const Installment = ({ installment }: { installment: { tenure: number; bank_name: string } }) => {
  const { t } = useTranslation();
  const tenureMonths = getTenure(installment.tenure);

  const pairsList = [
    {
      label: t('innerLayout.transactionsPage.singleTransactionsPage.detailsBoxes.installment.bankName'),
      value: installment.bank_name || EMPTY_VALUE,
    },
    {
      label: t('innerLayout.transactionsPage.singleTransactionsPage.detailsBoxes.installment.tenure'),
      value: tenureMonths,
    },
  ];

  return (
    <SummaryBox
      title={t('innerLayout.transactionsPage.singleTransactionsPage.detailsBoxes.installmentInfo.title')}
      itemsList={pairsList}
    />
  );
};

export default Installment;
